// SD Environment variables are injected in the build process

declare const __ENV__: unknown;
export const ENV = __ENV__ as Record<string, string | undefined>;
const ENVIRONMENTS = ['test', 'dev', 'int1', 'int5', 'uat', 'prod'] as const;
export type DeployEnvironment = typeof ENVIRONMENTS[number];
export const environment = ENVIRONMENTS.find(env => ENV.SD_ENVIRONMENT === env) || 'dev';
